import {REPORT_ALL_REFERRALS} from '/enum/records.enum';

export default {
  reportName: REPORT_ALL_REFERRALS,
};
